import { Btn } from "@/components/Btn";

export function UnsavedChangesBanner({
  viewName,
  onDismiss,
  onSave,
}: {
  viewName: string | null;
  onDismiss: () => void;
  onSave: () => void;
}) {
  return (
    <div
      className="card"
      style={{
        padding: "10px 14px",
        marginBottom: 14,
        background: "var(--c-info-50, #e8f1ff)",
        borderColor: "transparent",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 14,
      }}
    >
      <div style={{ fontSize: 13 }}>
        <b>You&apos;ve changed the default dashboard.</b>{" "}
        {viewName
          ? `Current layout no longer matches "${viewName}". Save it as a new view?`
          : "Save your layout as a dashboard view so you can come back to it?"}
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <Btn size="sm" onClick={onDismiss}>
          Ignore
        </Btn>
        <Btn size="sm" variant="primary" onClick={onSave}>
          Save
        </Btn>
      </div>
    </div>
  );
}
